import { render } from "./LayoutPrivate.vue?vue&type=template&id=5960cca1"
import script from "./LayoutPrivate.vue?vue&type=script&lang=js"
export * from "./LayoutPrivate.vue?vue&type=script&lang=js"

import "./LayoutPrivate.vue?vue&type=style&index=0&id=5960cca1&lang=sass"
script.render = render

export default script